import Mine from '@/views/mine/Mine';
import ApplyPay from '@/views/mine/ApplyPay';
import NotarizationNumber from '@/views/mine/NotarizationNumber';
export default  [
    {
        path: '/mine',
        name: '我的',
        meta: {
            tab: {
                name: '我的',
                icon: 'icon icon-user11',
                iconActive: 'icon icon-user3',
            }
        },
        component: Mine
    },
    {
        path: '/mine/applypay',
        name: '批量计费',
        component: ApplyPay
    },
    {
        path: '/mine/notarizationnumber',
        name: '公证书操作',
        component: NotarizationNumber
    }
]
